'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _constants = require('../../constants');

var Constants = _interopRequireWildcard(_constants);

var _componentsToolbar = require('../../components/Toolbar');

var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);

var _reactBootstrap = require('react-bootstrap');

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactisModal = require('reactis-modal');

var _componentsFormDB = require('../../components/FormDB');

var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);

var _reactisLoader = require('reactis-loader');

var _componentsActionButton = require('../../components/ActionButton');

var _componentsActionButton2 = _interopRequireDefault(_componentsActionButton);

var _componentsSaveButton = require('../../components/SaveButton');

var _componentsSaveButton2 = _interopRequireDefault(_componentsSaveButton);

var _componentsFormClientLookup = require('../../components/Form/ClientLookup');

var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);

var _components = {
	_$Form: {
		displayName: 'Form'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Form = (function (_FormDB) {
	_inherits(Form, _FormDB);

	function Form(props, context) {
		_classCallCheck(this, _Form);

		_FormDB.call(this, props, context);

		this.api = {
			fetch: 'client.fetch',
			save: 'client.save',
			remove: 'client.delete'
		};

		this.changeEvent = 'client.change';

		this.messages = {
			remove: 'Opravdu chcete zákazníka odstranit?',
			notfound: 'Zákazník nenalezen!'
		};

		this.schema = {
			title: {
				'class': _reactisInputs.TextInput,
				label: 'Obchodní název',
				rules: {
					presence: { message: 'Zadejte obchodní název!' }
				}
			},

			ic: {
				'class': _reactisInputs.TextInput,
				label: 'IČ',
				style: { width: 120 }
			},

			dic: {
				'class': _reactisInputs.TextInput,
				label: 'DIČ',
				style: { width: 120 }
			},

			sector: {
				'class': _reactisInputs.TextInput,
				label: 'Obor'
			},

			email: {
				'class': _reactisInputs.TextInput,
				label: 'E-mail'
			},

			phone: {
				'class': _reactisInputs.TextInput,
				label: 'Telefon'
			},

			street: {
				'class': _reactisInputs.TextInput,
				label: 'Ulice'
			},

			city: {
				'class': _reactisInputs.TextInput,
				label: 'Město',
				style: { width: 250 }
			},

			zip: {
				'class': _reactisInputs.TextInput,
				label: 'PSČ',
				style: { width: 80 }
			},

			invoice_street: {
				'class': _reactisInputs.TextInput,
				label: 'Ulice'
			},

			invoice_city: {
				'class': _reactisInputs.TextInput,
				label: 'Město',
				style: { width: 250 }
			},

			invoice_zip: {
				'class': _reactisInputs.TextInput,
				label: 'PSČ',
				style: { width: 80 }
			},

			image: {
				'class': _reactisInputs.ImageUpload,
				label: 'Logo'
			},

			notice: {
				'class': _reactisInputs.TextArea,
				label: 'Interní poznámka',
				style: { height: '60px' }
			}
		};
		this.form = new _reactisForms.FormManager(this.schema);
	}

	Form.prototype.componentDidMount = function componentDidMount() {
		var _this = this;

		this.form.on('change', function (key, value) {
			if (key == 'title') {
				_this.title = value;
			}
			_this.changed = true;
		});
		_FormDB.prototype.componentDidMount.call(this);
	};

	Form.prototype.updateTab = function updateTab(data) {
		this.props.updateTab({ title: data.title });
	};

	Form.prototype.render = function render() {
		var _this2 = this;

		var btns = _react2['default'].createElement(
			_reactBootstrap.ButtonToolbar,
			null,
			_react2['default'].createElement(_reactisLoader.LoadingButton, {
				loading: !!(this.props.form && this.props.form.get('saving')),
				disabled: !this.form.isChanged(),
				title: 'Uložit',
				onClick: function () {
					return _this2.save();
				}
			}),
			this.props.id > 0 && _react2['default'].createElement(
				_reactBootstrap.Button,
				{ bsStyle: 'danger', className: 'input-group', onClick: function () {
						return _this2.remove();
					} },
				_react2['default'].createElement('i', { className: 'fa fa-trash-o' }),
				' Odstranit'
			)
		);

		return _react2['default'].createElement(
			'div',
			{ style: { position: 'relative' } },
			_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
			_react2['default'].createElement(
				_reactisForms.RxForm,
				{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
				_react2['default'].createElement(_componentsToolbar2['default'], { title: 'Subjekt', buttons: btns }),
				_react2['default'].createElement(
					'div',
					{ className: 'row' },
					_react2['default'].createElement(
						'div',
						{ className: 'col-md-6' },
						_react2['default'].createElement(
							'table',
							{ className: 'form' },
							_react2['default'].createElement(
								'tbody',
								null,
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'title', labelWidth: '135' }),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'form' }),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'phone' }),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'email' }),
								_react2['default'].createElement(
									'tr',
									null,
									_react2['default'].createElement(
										'th',
										null,
										'IČ:'
									),
									_react2['default'].createElement(
										'td',
										null,
										_react2['default'].createElement(_reactisForms.FormField, { name: 'ic' }),
										'   DIČ: ',
										_react2['default'].createElement(_reactisForms.FormField, { name: 'dic' }),
										_react2['default'].createElement(
											_reactBootstrap.Button,
											{ className: 'hide', onClick: function (e) {
													return null;
												}, bsStyle: 'default', href: '#', style: { marginTop: -1, marginLeft: 20 } },
											_react2['default'].createElement('i', { className: 'clip-download' }),
											' Načíst data z ARESu'
										)
									)
								),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'image' }),
								_react2['default'].createElement(
									'tr',
									{ className: 'divider' },
									_react2['default'].createElement(
										'td',
										{ colSpan: '2' },
										_react2['default'].createElement(
											'h6',
											null,
											'Fakturační adresa'
										)
									)
								),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'invoice_street' }),
								_react2['default'].createElement(
									'tr',
									null,
									_react2['default'].createElement(
										'th',
										null,
										'Město:'
									),
									_react2['default'].createElement(
										'td',
										null,
										_react2['default'].createElement(_reactisForms.FormField, { name: 'invoice_city' }),
										'   PSČ: ',
										_react2['default'].createElement(_reactisForms.FormField, { name: 'invoice_zip' })
									)
								),
								_react2['default'].createElement(
									'tr',
									{ className: 'divider' },
									_react2['default'].createElement(
										'td',
										{ colSpan: '2' },
										_react2['default'].createElement(
											'h6',
											null,
											'Adresa'
										)
									)
								),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'street' }),
								_react2['default'].createElement(
									'tr',
									null,
									_react2['default'].createElement(
										'th',
										null,
										'Město:'
									),
									_react2['default'].createElement(
										'td',
										null,
										_react2['default'].createElement(_reactisForms.FormField, { name: 'city' }),
										'   PSČ: ',
										_react2['default'].createElement(_reactisForms.FormField, { name: 'zip' })
									)
								),
								_react2['default'].createElement(
									'tr',
									{ className: 'divider' },
									_react2['default'].createElement(
										'td',
										{ colSpan: '2' },
										' '
									)
								),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'notice' }),
								_react2['default'].createElement(
									'tr',
									{ className: 'buttons' },
									_react2['default'].createElement('td', { style: { width: 135 } }),
									_react2['default'].createElement(
										'td',
										null,
										_react2['default'].createElement(_reactisLoader.LoadingButton, {
											loading: !!(this.props.form && this.props.form.get('saving')),
											title: 'Uložit',
											disabled: !this.form.isChanged(),
											onClick: function () {
												return _this2.save();
											}
										})
									)
								)
							)
						)
					)
				)
			)
		);
	};

	var _Form = Form;
	Form = _wrapComponent('_$Form')(Form) || Form;
	Form = _reactRedux.connect(function (state, props) {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	}, function (dispatch) {
		return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
	}, null, { withRef: true })(Form) || Form;
	return Form;
})(_componentsFormDB2['default']);

exports['default'] = Form;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Client/Form.js
 ** module id = 979
 ** module chunks = 2
 **/